<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-date-picker
                        v-model="form.workDate"
                        type="month"
                        style="width:120px;"
                        value-format="yyyy-MM"
                        :placeholder="form.placeholderWorkDate">
                    </el-date-picker>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="姓名"></el-input>
                    </div>
                </div>
                 <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.deptName" placeholder="部门名称"></el-input>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                    &nbsp;&nbsp;
                    <el-button type="primary" icon="search" @click="exportExcel">导出Excel</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="姓名" width="100"></el-table-column>
                <el-table-column prop="deptName" label="部门名称" :show-overflow-tooltip="true" width="130"></el-table-column>
                <el-table-column prop="identityCard" label="身份证"  :show-overflow-tooltip="true" width="150"></el-table-column>
                <el-table-column prop="attendanceDays" label="出勤天数"></el-table-column>
                <el-table-column prop="sickDays" label="病假天数" ></el-table-column>
                <el-table-column prop="thingDays" label="事假天数" ></el-table-column>
                <el-table-column prop="minerDays" label="旷工次数" ></el-table-column>
                <el-table-column prop="lateDays" label="迟到次数" ></el-table-column>
                <el-table-column prop="missingDays" label="缺卡次数" ></el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>

        <!-- 人员弹出框 
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>-->
    </div>
</template>

<script>
    import axios from 'axios'
    import http from '../../../common/http';
    // import userTransfer from './UserTransfer.vue';

    export default {
        name:"TeacherCount",
        data(){
            return{
                menuName:"",
                transferVisible:false,
                loading:false,
                loadingText:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    name:"",
                    workDate:"",
                    placeholderWorkDate:"",
                    deptId:"",
                    deptName:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[]
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
            let nowDate = new Date();
            let date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate(),
            }
            if(date.month < 10){
                this.form.workDate=date.year+"-0"+date.month
            }else{
               this.form.workDate=date.year+"-"+date.month 
            }
            this.form.placeholderWorkDate=this.form.workDate;
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // deptCheck(){
            //    this.deptId=this.$refs['rootTree'].getCheckedKeys();
            //    this.getData();
            // },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中...";
                let url  = this.listTeacherDayCountUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    name:this.form.name,
                    deptName:this.form.deptName,
                    workDate:this.form.workDate==null?"":this.form.workDate,
                    deptId:this.form.deptId
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
           },
           exportExcel(){
                let msg="导出考勤数据只支持导出1W条，超出会导出失败，请确认当前页面总条数！";
                this.$commonFn.showConfirm2(msg,this.exportData);
           },
           exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";
                let url=this.excelDownloadTeacherDayUrl;
                let param = new URLSearchParams();
                // param.append('isPage', this.common.isPage);
                // param.append('page', this.common.page);
                // param.append('limit', this.common.pageSize);
                param.append('name', this.form.name);
                param.append('deptName',this.form.deptName);
                param.append('workDate', this.form.workDate==null?"":this.form.workDate);
                param.append('deptId', this.form.deptId);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    // console.log(decodeURI(res.headers['filename']));
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '教职考勤统计.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error);
                    this.loading=false;
                });
           },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.trafficRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            //批量删除管理员
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.form.id= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2);
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            },
            // findUser(){
            //     this.transferVisible=true;
            //     this.$nextTick(() => {
            //         this.$refs['userTransfer'].init(this.form.userId);
            //     })
            // },
            // setUser(userId,name){
            //     this.form.userId = userId;
            //     this.form.name = name;
            // }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/count/TeacherCount.vue